var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"shoes-hero"},[_c('div',{staticClass:"shoes-hero-text"},[_c('h1',[_vm._v("Leather Shoes")]),_c('p',[_vm._v(" Discover timeless leather shoes crafted for everyday style, comfort, and lasting quality. ")])]),_c('div',{staticClass:"shoes-hero-image"},[_c('img',{attrs:{"src":require("../assets/theranger.avif"),"alt":"Leather Shoes"}})])])
}]

export { render, staticRenderFns }